import { TypographyStyles } from '@/styles'
import {
  selectFilingLocation,
  selectMailingLocation,
} from '../payroll.selectors'
import { Icon, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { faMapMarkerAlt } from '@fortawesome/pro-regular-svg-icons'
export const LocationsPanel = ({ title }: { title: string }) => {
  const filingLocation = useReselector(selectFilingLocation)
  const mailingAddress = useReselector(selectMailingLocation)

  const areSameLocation =
    Boolean(filingLocation) && filingLocation?.uuid === mailingAddress?.uuid

  if (!filingLocation) {
    return null
  }

  const { street_1, street_2, city, state, zip } = filingLocation

  return (
    <div className="flex flex-col gap-4">
      <Text variant={TypographyStyles.H3}>
        <b className="inline-flex items-center gap-2">
          <Icon icon={faMapMarkerAlt} />
          {title}
        </b>
      </Text>

      <Text variant={TypographyStyles.BODY_SM}>
        We need an accurate company address for tax filing purposes. This should
        be the address registered to your business.
      </Text>

      <div className="flex flex-col md:flex-row gap-6">
        <div className="flex flex-col gap-2 w-full md:w-1/2">
          <Text>
            <b>
              {areSameLocation
                ? 'Filing and mailing address:'
                : 'Filing address'}
            </b>
          </Text>
          <Text variant={TypographyStyles.BODY_SM}>
            {street_1} {street_2 || ''}
          </Text>
          <Text variant={TypographyStyles.BODY_SM}>
            {city}, {state} {zip}
          </Text>
        </div>

        {!areSameLocation && mailingAddress && (
          <div className="flex flex-col gap-2 w-full md:w-1/2">
            <Text>
              <b>Mailing Address</b>
            </Text>
            <Text variant={TypographyStyles.BODY_SM}>
              {mailingAddress.street_1} {mailingAddress.street_2 || ''}
            </Text>
            <Text variant={TypographyStyles.BODY_SM}>
              {mailingAddress.city}, {mailingAddress.state} {mailingAddress.zip}
            </Text>
          </div>
        )}
      </div>
    </div>
  )
}
